import React, { FC, memo }  from 'react';
import styled, {
  Interpolation,
}                           from 'styled-components';
import { CircularProgress } from '@material-ui/core';
import { Button }           from '@components/Button/Button';
import { ModalDialog }      from '@components/ModalDialog/ModalDialog';
import Cup                  from '@assets/icons/winner-cup.svg';
import { IFetchBid }        from '@typings/auction';

interface IStyledProps {
  width?      : string;
  isPrimary?  : boolean;
  fontWeight? : number;
}

const LoaderWrapper = styled.div`
  display         : flex;
  justify-content : center;
`;

const ContentWrapper = styled.div`
  position : relative;
  padding  : 30px;

  div:nth-child(odd) {
    background-color: #E1F3FE;
  }
`;

const ItemWrapper = styled.div`
  display         : flex;
  justify-content : space-between;
`;

const EmptyItems = styled.h2`
  text-align: center;
`;

const IconWrapper = styled.span`
  position : absolute;
  left     : 2px;

  & svg {
    fill   : ${({ theme: { textColor } }) => textColor.secondary};
    width  : 15px;
    margin : 0 5px 0 0;
  }
`;

const Item = styled.span<IStyledProps>`
  min-width     : ${({ width }): string => width || '200px'};
  color         : ${({ isPrimary, theme: { textColor } }): string => (isPrimary ? textColor.primary : textColor.black)};
  overflow      : hidden;
  white-space   : nowrap;
  text-overflow : ellipsis;
  margin        : 0 10px;
  font-weight   : ${({ fontWeight }): Interpolation<IStyledProps> => fontWeight};
`;

interface IProps {
  isOpen      : boolean;
  isLoading   : boolean;
  currentBid  : IFetchBid[];
  toggleModal : () => void;
}

const BidListModalBase: FC<IProps> = ({
  isOpen,
  isLoading,
  currentBid,
  toggleModal,
}) => {
  const bidListContent = (items: IFetchBid[]) => (
    <>
      <h1>Bid List</h1>

      <ContentWrapper>
        {items.length ? items.map((item: IFetchBid, index: number) => (
          <ItemWrapper key={`${item.bidDate} ${item.bidTime}`}>
            {index === 0 && (
              <IconWrapper><Cup /></IconWrapper>
            )}
            <Item fontWeight={400} isPrimary>{item?.bidder ?? ''}</Item>
            <Item fontWeight={400}>$ {item?.amount ?? ''}</Item>
            <Item>{item?.bidDate ?? ''}</Item>
            <Item>{item?.bidTime ?? ''}</Item>
          </ItemWrapper>
        )) : (
          <EmptyItems>Bid list is empty</EmptyItems>
        )}
      </ContentWrapper>
    </>
  );

  return (
    <ModalDialog
      open     = {isOpen}
      content  = {
        isLoading ? (
          <LoaderWrapper>
            <CircularProgress color="secondary" />
          </LoaderWrapper>
        ) : bidListContent(currentBid)
      }
      minWidth = {!isLoading && currentBid.length ? '1000px' : '300px'}
      actions  = {(
        <Button
          label   = "Cancel"
          variant = "outlined"
          width   = "180px"
          onClick = {toggleModal}
        />
      )}
    />
  );
};

export const BidListModal = memo(BidListModalBase);
